export default __webpack_public_path__ + "static/media/gurujimaharaj.2fdf79a9.jpeg";